import script from "./PortfolioBasketSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioBasketSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioBasketSwitcher.vue?vue&type=style&index=0&id=5c2781ed&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c2781ed"]])

export default __exports__